import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { miningList } from '../../constants/bakery/lists'
import { updateMiningPairMap } from './actions'

export default function Updater(): null {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updateMiningPairMap({list: miningList}))
  }, [dispatch])

  return null
}